import React, { useState } from 'react';
import { setAtOrgan } from '../../services/seasonViewService';

/**
 * "Am I on the bench for this piece?" — the one FILLED badge in the system,
 * which is what makes it scannable at a glance down a whole season.
 *
 * Shared by the season grid and the Sunday page so the two cannot drift. When
 * it is OFF it renders as a faint outline that only appears on hover, so a
 * grid of unmarked hymns stays quiet.
 */
const AtKeyboard: React.FC<{
  selectionId: number;
  on: boolean;
  onChanged: () => void;
}> = ({ selectionId, on, onChanged }) => {
  const [busy, setBusy] = useState(false);

  const toggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      await setAtOrgan(selectionId, !on);
      onChanged();
    } finally { setBusy(false); }
  };

  return (
    <button
      type="button"
      className={`sv-atkeyboard${on ? '' : ' sv-atkeyboard--off'}`}
      title={on ? 'You are at the organ for this — click to unset' : 'Mark that you are at the organ for this'}
      onClick={toggle}
    >
      at the organ
    </button>
  );
};

export default AtKeyboard;
